// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__qELOa","header":"PatientBlock_header__3dTGR","label":"PatientBlock_label__31PgE","option":"PatientBlock_option__1zDmK"};